// Main.jsx
import React from 'react';
import styles from './Main.module.css';
import Hero from '../Hero/Hero';
import ScrollHint from '../Sections/ScrollHint';
import Features from '../Sections/Features';
import HowToStart from '../Sections/HowToStart';
import Faq from '../Sections/Faq';

const Main = () => {
  return (
    <main className={styles.mainContent} id="main">
      <Hero />
      <ScrollHint />
      <Features />
      <HowToStart />
      <Faq />
    </main>
  );
};

export default Main;
